<template>
  <div class="tags-container">
    <div v-for="section in sections" :key="section.id" class="tags-group">
      <div class="tags-group-name mb-2 mt-2">{{ section.name }}</div>
      <div class="tags-list">
        <div v-for="tag in section.tags" :key="tag.id" class="tag-item">
          <DataEnabledTag
            v-if="tag.category === 'data-enabled'"
            :tag="tag"
            :color="color"
            :tags-selected="twiageCase && twiageCase.tags ? twiageCase.tags : []"
            @modify-case="onModifyCase"
          />

          <Tag
            v-else
            :tag="tag"
            :color="color"
            :tags-selected="twiageCase && twiageCase.tags ? twiageCase.tags : []"
            @modify-case="onModifyCase"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Tag from "@/Case/components/Tag";
import DataEnabledTag from "@/Case/components/DataEnabledTag";
import { CaseEvent } from "@/Case/CaseEvent";

export default {
  name: "TagsList",
  components: { Tag, DataEnabledTag },
  props: {
    sections: {
      type: Array,
      default: () => [],
    },
    color: {
      type: String,
      default: () => "#AAAAAA",
    },
    twiageCase: {
      type: Object,
      default: () => undefined,
    },
  },

  methods: {
    onModifyCase(event) {
      this.$emit(CaseEvent.MODIFY, event);
    },
  },
};
</script>

<style scoped>
.tags-group-name {
  font-size: 0.8rem;
  text-transform: uppercase;
  font-weight: bold;
  text-align: left;
  color: #bbb;
}
.tags-list {
  display: flex;
  flex-wrap: wrap;
}
.tag-item {
  padding: 0.2em;
  cursor: pointer;
}
</style>
